module.exports = __webpack_public_path__ + "static/media/visiretail2.80a27ff1.svg";